var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.8,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.37 2.484 2.449 16.348a.044.044 0 0 1 0 .026l5.175 5.175h.003c.008 0 .015.002.021.007l13.926-13.87-5.204-5.202ZM2.44 16.366c-.001-.003-.005-.002-.006.001l-1.896 6.36a.61.61 0 0 0 .734.736l6.352-1.894a.01.01 0 0 0 .004-.016l-5.187-5.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.574 7.687.81-.867A3.678 3.678 0 0 0 20.742.645a3.681 3.681 0 0 0-3.563.972l-.81.867 5.204 5.203Z"
  }))));
};
export default SvgPencil;